import { render, staticRenderFns } from "./provisionCommand.vue?vue&type=template&id=1c5b2c24&scoped=true"
import script from "./provisionCommand.vue?vue&type=script&lang=js"
export * from "./provisionCommand.vue?vue&type=script&lang=js"
import style0 from "./provisionCommand.vue?vue&type=style&index=0&id=1c5b2c24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5b2c24",
  null
  
)

export default component.exports